import { toast } from 'react-toastify';

let uninstallCurrent: (() => void) | null = null;

export const OUTAGE_TOAST_ID = 'service-unavailable-save';
export const OUTAGE_NOTICE =
  'Last save missing? Once the message at the top of the page is gone, check before entering it again.';

// Error toasts raised by failed saves would repeat, one per widget, what the
// service-unavailable banner already says once. Modals sit above the banner
// and report failures only through toasts, so one notice with a fixed id
// stays visible instead of leaving a refused save silent.
export const installErrorToastGate = (isUnavailable: () => boolean) => {
  uninstallCurrent?.();
  const original = toast.error;
  toast.error = ((...args: Parameters<typeof toast.error>) =>
    isUnavailable()
      ? original(OUTAGE_NOTICE, { toastId: OUTAGE_TOAST_ID })
      : original(...args)) as typeof toast.error;

  const uninstall = () => {
    toast.error = original;
    if (uninstallCurrent === uninstall) uninstallCurrent = null;
  };
  uninstallCurrent = uninstall;
  return uninstall;
};
